<div>
   <mat-label class='label'>Name: </mat-label><span [contentEditable]=true
      (blur)='sendChange($event)'>{{formState.groups.incomplete.selected['mad_person_name-display_name'] }}</span>
   <mat-label class='label'>Phone:</mat-label><span
      [contentEditable]=true>{{formState.groups.incomplete.selected['mad_phone-phone'] | mask : '(000) 000-0000'}}</span>
   <mat-label class='label'>Email:</mat-label><span
      [contentEditable]=true>{{formState.groups.incomplete.selected['mad_email-address']}}</span>
</div>